export default "__VITE_ASSET__34Zr_Axf__"